import 'swiper/css';
import useNewsFeed from '@dehaat/kisan-app-bl/hooks/useNewsFeeds';
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import HeaderWithBackButton from '@/components/HeaderWithBackButton';
import NewsFeed from '@/components/news/NewsFeed';
import SocialMetaTags from '@/components/SocialMetaTags';
const NewsPage = () => {
  const {
    t
  } = useTranslation('news');
  const [activeSlide, setActiveSlide] = useState(0);
  const {
    locale,
    query: {
      element_id
    }
  } = useRouter();
  const {
    news,
    getNewsFeeds,
    fetchNext
  } = useNewsFeed(
  //Setting hindi as default locale until we have news available in other languages
  'hi', element_id ? Number(element_id) : undefined);
  useEffect(() => {
    getNewsFeeds();
  }, [getNewsFeeds]);
  return <>
      {news[activeSlide] && <SocialMetaTags title={news[activeSlide].name || 'Krishi News'} url={`${locale}/news`} image={news[activeSlide].attachments.images[0]} description={news[activeSlide].content} />}
      <main className="relative">
        <HeaderWithBackButton heading={t('news')} data-sentry-element="HeaderWithBackButton" data-sentry-source-file="news.tsx" />
        <section className="relative m-auto max-w-7xl w-full">
          <Swiper direction="vertical" className="h-screen" onSlideChange={swiper => {
          setActiveSlide(swiper.activeIndex);
          if (swiper.activeIndex === news.length - 2) {
            fetchNext();
          }
        }} data-sentry-element="Swiper" data-sentry-source-file="news.tsx">
            {news.map((newsInfo, index) => <SwiperSlide key={`${newsInfo.id}-${index}`}>
                <NewsFeed news={newsInfo} nextNews={news[index + 1]} />
              </SwiperSlide>)}
          </Swiper>
        </section>
      </main>
    </>;
};
export const getServerSideProps: GetServerSideProps = async () => {
  return {
    props: {
      title: 'News'
    }
  };
};
export default NewsPage;